import {createContext} from 'react'

export const PaginateContext = createContext({
  sortBy: "",
  setSortBy: () => {
  },
  sortType: "",
  setSortType: () => {
  },
  active: 1,
  setActive: () => {
  },
  totalRows: 0,
  rowsCount: 0,
  setRowsCount: () => {
  },
  from: 1,
  to: 1,
})